var render = function render(){var _vm=this,_c=_vm._self._c;return _c('d-page',{attrs:{"title":_vm.$t('companies.page-heading')}},[_c('template',{slot:"content"},[_c('List')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }